"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toastr = {
  newestOnTop: true,
  preventDuplicates: true
};

exports.default = toastr;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-toastr/lib/config.js
// module id = 601
// module chunks = 0 1 2